import { gangtokInstance as http } from "./http-common";

const login = (data) => {
  return http.post("DashboardLogin/getlogin", data).then((response) => {
    const token = response.data.token;
    if (token) {
      localStorage.setItem("token", JSON.stringify(response.data.token));
      const uss = {
        userid: response.data.usreid,
        userName: response.data.username,
      };
      localStorage.setItem("user", JSON.stringify(uss));
    }

    return response.data;
  });
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.clear();
};

const getToken = () => {
  return JSON.parse(localStorage.getItem("token"));
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const AuthService = {
  login,
  logout,
  getToken,
  getCurrentUser,
};

export default AuthService;
